import React from "react";
import Select from "react-select";
import { docTypeOptions, receivedDocsOptions } from "./masterList";

const OutDocumentModal = ({
  show,
  onClose,
  onSubmit,
  receivedDocs,
  setReceivedDocs,
  docType,
  setDocType,
  senderName,
  setSenderName,
  securitySewadars,
  formData,
  handleChange
}) => {
  const handleReceivedDocsChange = (selected) => {
    const value = selected ? selected.value : "";
    setReceivedDocs(value);

    if (value === "yes") {
      // Clear "no" related fields
      handleChange({ target: { name: "permitBy", value: "" } });
      handleChange({ target: { name: "byWhom", value: "" } });
      handleChange({ target: { name: "medium", value: "" } });
      handleChange({ target: { name: "permitByDate", value: "" } });
      handleChange({ target: { name: "permitByTime", value: "" } });
      handleChange({ target: { name: "authorityName", value: "" } });
      handleChange({ target: { name: "letterIssuerName", value: "" } });
    } else if (value === "no") {
      // Clear "yes" related fields
      setDocType("");
      setSenderName("");
    }
  };

  const handleDocTypeChange = (selected) => {
    const value = selected ? selected.value : "";
    setDocType(value);

    if (value == "physical") {
      // Clear "digital" fields
      setSenderName("");
    }
  };

  const [selectedSewadar, setSelectedSewadar] = React.useState(null);

  const sewadarOptions =
    securitySewadars?.map((sewadar) => ({
      value: sewadar.badgeId,
      label: `${sewadar.badgeId} - ${sewadar.name}`,
      ...sewadar
    })) || [];

  const handleSewadarChange = (selectedOption) => {
    setSelectedSewadar(selectedOption);
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      style={{
        backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent",
        backdropFilter: show ? "blur(2px)" : "none"
      }}
    >
      <div className="modal-dialog modal-lg">
        <form className="modal-content" onSubmit={onSubmit}>
          <div className="modal-header">
            <h5 className="modal-title">दस्तावेज़ पुष्टि</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {/* ✅ मूल दस्तावेज़ */}
            <div className="row mb-3">
                  {/* ✅ प्राप्त करने का तरीका */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">मूल दस्तावेज़ों की प्रति प्राप्त करने का तरीका</label>
                    <Select
                      options={docTypeOptions}
                      value={docTypeOptions.find(opt => opt.value == docType) || null}
                      onChange={handleDocTypeChange}
                      placeholder="चयन करें"
                      isClearable
                      required
                    />

                  </div>
                  {docType == "digital" && (
                    <div className="col-md-5 mb-3">
                      <label className="form-label">इलेक्ट्रॉनिक / वाट्सअप पर किसके द्वारा चालान / गेट पास भेजा गया (नाम)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={senderName}
                        onChange={(e) => setSenderName(e.target.value)}
                        required
                      />
                    </div>
                  )}

            </div>
                <div className="mt-4 border"></div>
                <h6 className="mt-2">वाहन किसके द्वारा बाहर किया गया ( बिलवा गेट नं 1 के सेवादार का विवरण )</h6>
                <div className="mt-1 border"></div>
                <div className="row mt-1">
                  <div className="col-md-6">
                    <label className="form-label">बैज आई. डी.</label>
                    <Select
                      options={sewadarOptions}
                      value={selectedSewadar}
                      onChange={handleSewadarChange}
                      placeholder="सेवादार चुनें"
                      isSearchable
                      required
                    />
                  </div>

                  {selectedSewadar && (
                    <>
                      <div className="col-md-6">
                        <label className="form-label">नाम</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedSewadar.name || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">मोबाइल नंबर</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedSewadar.sewadarMobileNo || ""}
                          readOnly
                        />
                      </div>

                      {/* ✅ Exit Date */}
                      <div className="col-md-3 mt-3">
                        <label className="form-label">बाहर निकलने की तारीख</label>
                        <input
                          type="date"
                          className="form-control"
                          name="exitDate"
                          value={formData.exitDate || ""}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* ✅ Exit Time */}
                      <div className="col-md-3 mt-3">
                        <label className="form-label">बाहर निकलने का समय</label>
                        <input
                          type="time"
                          className="form-control"
                          name="exitTime"
                          value={formData.exitTime || ""}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </>
                  )}
                </div>


          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              रद्द करें
            </button>
            <button type="submit" className="btn btn-primary">
              आगे बढ़ें
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OutDocumentModal;
